module.exports = __webpack_public_path__ + "img/responsibility_3.7004f052.jpg";